import b from 'b_';
import { Cog } from 'education-icons';
import { Text } from 'platform-components';
import React from 'react';

import './classes-select-settings.scss';

interface Props {
    short?: boolean;

    /** компонент используется только для скринридера */
    isA11y?: boolean;
}

export const ClassesSelectSettings = ({ short, isA11y }: Props) => (
    <div className={isA11y ? undefined : b('classes-select-settings', { short: short })}>
        <Cog />
        <Text id={`classes.select.settings${short ? '.short' : ''}`} />
    </div>
);
